import { render, staticRenderFns } from "./DeptTreeView.vue?vue&type=template&id=3bc9c913"
import script from "./DeptTreeView.ts?vue&type=script&lang=ts&external"
export * from "./DeptTreeView.ts?vue&type=script&lang=ts&external"
import style0 from "./DeptTreeView.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports